module.exports = __webpack_public_path__ + "static/media/gha_gold_blank.69e1a196.png";